export const COLORS = {
    primary: '#0077C2',
    primaryDark: '#004c91',
    primaryLight: '#59a5f5',
}